import { GetBuildingHistoryRes } from '@gateway.Building'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface BuildingHistoryState {
  buildingHistoryList: GetBuildingHistoryRes['buildingInfoList']
}

const initialState: BuildingHistoryState = {
  buildingHistoryList: []
}

const buildingHistorySlice = createSlice({
  name: 'buildinghistory',
  initialState,
  reducers: {
    setBuildingHistoryListData: (
      state,
      action: PayloadAction<BuildingHistoryState['buildingHistoryList']>
    ) => {
      state.buildingHistoryList = action.payload
    }
  }
})

export const BuildingHistoryActions = buildingHistorySlice.actions
export const BuildingHistoryReducers = buildingHistorySlice.reducer
